import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui";
export const DeleteApiKeyModal = ({ isOpen, apiKey, onClose, onConfirm, isLoading })=>{
    if (!isOpen || !apiKey) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50",
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative top-1/2 transform -translate-y-1/2 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between mb-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ _jsx(AlertTriangle, {
                                            className: "h-6 w-6 text-red-600"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "ml-2 text-lg font-medium text-gray-900",
                                        children: "Delete API Key"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                onClick: onClose,
                                className: "text-gray-400 hover:text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed",
                                disabled: isLoading,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-only",
                                        children: "Close"
                                    }),
                                    /*#__PURE__*/ _jsx(X, {
                                        className: "h-6 w-6"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-600 mb-3",
                                children: "Are you sure you want to delete this API key? This action cannot be undone."
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "bg-gray-50 p-3 rounded-md",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "text-sm",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "font-medium text-gray-900 mb-1",
                                            children: apiKey.name
                                        }),
                                        apiKey.description && /*#__PURE__*/ _jsx("div", {
                                            className: "text-gray-600",
                                            children: apiKey.description
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-end space-x-3",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                variant: "simple",
                                buttonStyle: "flat",
                                onClick: onClose,
                                disabled: isLoading,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                variant: "simple",
                                color: "red",
                                onClick: onConfirm,
                                disabled: isLoading,
                                children: isLoading ? 'Deleting...' : 'Delete API Key'
                            })
                        ]
                    })
                ]
            })
        })
    });
};
